import React from 'react';

import { YatLogo } from '@pkg/assets/brand';

import { IconWrapper, StyledSkeleton } from './styles';

export interface SkeletonProps {
    id?: string;
}

export function Skeleton({ id }: SkeletonProps) {
    return (
        <StyledSkeleton id={id}>
            <IconWrapper>
                <YatLogo />
            </IconWrapper>
        </StyledSkeleton>
    );
}
